import { getGdprSubmissionText } from './getGdprSubmissionText';
export const getLegalConsentOptionsForSignupRequest = () => {
  return {
    legitimateInterest: true,
    consentText: getGdprSubmissionText()
  };
};